module.exports = __webpack_public_path__ + "img/beautiful-rect.97c79e7f.png";